
import React, { useState, useEffect } from 'react';

import '../css/listOfFilesPopUp.css';
import SearchableDropdown from '../SearchableDropdown';


import {
    showCatalogSchemas, showCatalogSchemasTables, showCatalogSchemasTablesColumns,
    fetchSqliteListTables, fetchSqliteListColumns
} from '../authorization/FetchToken';

function ListOfFilesDeletePopupComponent({ loadDatabaseList, setLoadDatabaseList, loadTableList,
    setLoadTableList,
    node, onClose, schema, setSchema, table,
    setTable, chunk, setChunk, delimeter, setDelimeter, onValueSubmit }) {

    console.log(JSON.stringify(loadDatabaseList) + "loadDatabaseList");
    console.log(JSON.stringify(loadTableList) + "loadTableList");

    const loadDatabaseListOptions = loadDatabaseList.map(item => ({
        label: item,
        value: item,
    }));

    const renderSchemasOptions = () => {
        return loadTableList.map((schema, index) => (
            <option key={index} value={schema}>
                {schema}
            </option>
        ));
    };

    const dropDownFields = [
        // { value: '', label: 'Select a window function' },
        { value: 'append', label: 'Append' },
        { value: 'replace', label: 'Replace' },
        { value: 'fail', label: 'Fail' },


        // Add more window functions as needed
    ];

    const fileFormatType = [
        // { value: '', label: 'Select a window function' },
        { value: 'csv', label: 'csv' },
        { value: 'json', label: 'json' },
        { value: 'excel', label: 'excel' },
        { value: 'parquet', label: 'parquet' }
        // Add more window functions as needed
    ];

    const [ifTableExists, setIfTableExists] = useState(dropDownFields[0].value);
    const [chunkSize, setChunkSize] = useState('');
    const [fileFormatTypeValue, setFileFormatTypeValue] = useState(fileFormatType[0].value);
    const [schemaDropdown, setSchemaDropdown] = useState(loadDatabaseListOptions.length > 0 ? loadDatabaseListOptions[0].value : '');

    const [isTableEmpty, setIsTableEmpty] = useState(false);
    const [enterDelete, isEnterDelete] = useState('');

    useEffect(() => {
        setSchemaDropdown(schemaDropdown);
        setSchema(schema);
        setTable(table);
        setFileFormatTypeValue(fileFormatTypeValue);
        // setIfTableExists(ifTableExists);
        // setChunkSize(chunkSize);
    }, [schema, table, fileFormatTypeValue
        // fileFormatTypeValue, ifTableExists, chunkSize
    ]
    );

    const handleSubmit = () => {
        // Implement your logic here for handling the form submission
        // You can access schema, table, chunk, delimeter, and columnType values here
        console.log('Schema:', schema);
        console.log('schemaDropdown:', schemaDropdown);

        console.log('Table:', table);
        console.log('enterDelete:', enterDelete);

        onValueSubmit(onClose, schemaDropdown, table, enterDelete, fileFormatTypeValue);
        // Close the popup
        //  onClose();
    };

    const handleTableChange = async (event) => {
        const schema = event.target.value;

        setTable(schema);
    };
    const handleDBListChange = async (value) => {
        // const schema = event.target.value;
        setSchemaDropdown(value);

        if (loadDatabaseListOptions.some(item => item.value === value)) {

            let tableNames = [];
            let columnNames = [];
            tableNames = await fetchSqliteListTables(value);
            console.log(JSON.stringify(tableNames) + "tableNames");
            if (tableNames.length > 0) {
                setLoadTableList(tableNames);
                setTable(tableNames[0]);
                setIsTableEmpty(false);
            } else {
                setTable(tableNames);
                setIsTableEmpty(true);
            }
        } else {
            setIsTableEmpty(true);
        }
    };



    return (
        <div className="overlay">

            <div className="file-popup-datatable">
                {/* <div className="popup-header"> */}



                <div className="input-container">
                    <h1>DELETE FILES</h1>
                    <div className="input-row">
                        <label className="file-fields" htmlFor="schema">Database:</label>

                        <SearchableDropdown className="labelTag"

                            options={loadDatabaseListOptions}
                            label="label"
                            id="value"
                            value={schemaDropdown}
                            selectedVal={schemaDropdown}
                            handleChange={handleDBListChange}
                        // handleChange={(e) => setSchema(e.target.value)}

                        />

                    </div>
                    <div className="input-row">
                        <label className="file-fields" htmlFor="table">Table:</label>
                        {isTableEmpty ? (
                            <input
                                className="file-fields-input"
                                type="text"
                                id="table"
                                value={table}
                                onChange={(e) => setTable(e.target.value)}
                            />
                        ) : (
                            <select
                                id="database"
                                className="form-control"
                                value={table}
                                onChange={handleTableChange}
                            >
                                {/* Options for the select dropdown */}
                                {renderSchemasOptions()}
                            </select>
                        )}
                    </div>
                    <div className="input-row">
                        <label className="file-fields" htmlFor="table">To confirm deletion, type delete in the text input field</label>

                        <input
                            className="file-fields-input"
                            type="text"
                            id="table"
                            value={enterDelete}
                            onChange={(e) => isEnterDelete(e.target.value)}
                        />
                    </div>

                    <button type="button" className="btn btn-removeall" onClick={handleSubmit}>DELETE</button>
                    <button type="button" onClick={onClose}>CLOSE</button>

                </div>

            </div>

        </div>
    );
}

export default ListOfFilesDeletePopupComponent;
